import * as React from 'react';

export const NotFound: React.SFC = props => (
   <div>Not Found</div>
);

